import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Chip = _resolveComponent("Chip");
    return (_openBlock(), _createBlock(_component_Chip, {
        "css-class": _ctx.chipColor,
        text: _ctx.$t(_ctx.uiLabel)
    }, null, 8 /* PROPS */, ["css-class", "text"]));
}
